<template>
  <div id="areaTree">
    <div class="tree-box" @click.stop="visible = true">
      <el-input class="tree-box__input"  placeholder="请输入标签名称" v-model="labelName" readonly="readonly" v-bind:disabled="isDisablePriority"></el-input>
      <div v-show="visible" class="zTreeDemoBackground left" style="height: 150px;overflow: auto" @click.stop="clickHandler">
        <ul id="treeDemo" class="ztree" ></ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'zTree',
  data() {
    return {
      log: '',
      className: 'dark',
      curDragNodes: [],
      autoExpandNode: null,
      newCount: 1,
      setting: {
        edit: {
          drag: {
            autoExpandTrigger: true,
            prev: this.dropPrev,
            inner: this.dropInner,
            next: this.dropNext
          },
          enable: true,
          showRemoveBtn: false,
          showRenameBtn: false,
          showAddBtn: false
        },
        view: {
          expandSpeed: '',
          removeHoverDom: this.removeHoverDom,
          selectedMulti: false,
          ontCss: this.getFont,
          nameIsHTML: true
        },
        data: {
          simpleData: {
            enable: true
          }
        },
        callback: {
          beforeDrag: this.beforeDrag,
          beforeDrop: this.beforeDrop,
          beforeDragOpen: this.beforeDragOpen,
          onDrag: this.onDrag,
          onDrop: this.onDrop,
          onExpand: this.onExpand
        }
      },
      zNodes: [
        { id: 1, pId: 0, name: '语料优先级', open: false, iconOpen: '../../../../static/plugins/ztree/css/zTreeStyle/img/diy/1_open.png', iconClose: '../../../../static/plugins/ztree/css/zTreeStyle/img/diy/1_close.png' }
      ],
      visible: false,
      num: 0,
      labelName: '',
      targetLabel: null,
      targetLabelType: null,

      isHave: false,
      newZnodes: [],
      startPoint: null,
      endPoint: null,
      moveDirectUp: true,
      targetOrderNum: null,
      currentId: null,
      isDisable: false,
      isDisablePriority: false,
      pendingDropInfo: null,
      isDropInProgress: false
    };
  },
  watch: {
    visible() {
      if (this.visible) {
        document.addEventListener('click', this.documentClickEvent);
      } else {
        document.removeEventListener('click', this.documentClickEvent);
      }
    }
  },
  methods: {
    dropPrev(treeId, nodes, targetNode) {
      const pNode = targetNode.getParentNode();
      if (pNode && pNode.dropInner === false) {
        return false;
      }
      for (let i = 0, l = this.curDragNodes.length; i < l; i++) {
        const curPNode = this.curDragNodes[i].getParentNode();
        if (curPNode && curPNode !== targetNode.getParentNode() && curPNode.childOuter === false) {
          return false;
        }
      }
      return true;
    },
    // eslint-disable-next-line
    dropInner(treeId, nodes, targetNode) {
      return false;
      // if (true) { // 仅仅允许同级移动，不允许插到内部形成父级
      //   return false;
      // }
      // for (let i = 0, l = this.curDragNodes.length; i < l; i++) {
      //   if (!targetNode && this.curDragNodes[i].dropRoot === false) {
      //     return false;
      //   } else if (this.curDragNodes[i].parentTId && this.curDragNodes[i].getParentNode() !== targetNode && this.curDragNodes[i].getParentNode().childOuter === false) {
      //     return false;
      //   }
      // }
      //
      // return true;
    },
    dropNext(treeId, nodes, targetNode) {
      const pNode = targetNode.getParentNode();
      if (pNode && pNode.dropInner === false) {
        return false;
      }
      for (let i = 0, l = this.curDragNodes.length; i < l; i++) {
        const curPNode = this.curDragNodes[i].getParentNode();
        if (curPNode && curPNode !== targetNode.getParentNode() && curPNode.childOuter === false) {
          return false;
        }
      }

      return true;
    },
    beforeDrag(treeId, treeNodes) {
      this.className = (this.className === 'dark' ? '' : 'dark');
      this.showLog(`[ ${this.getTime()} beforeDrag ]&nbsp;&nbsp;&nbsp;&nbsp; drag: ${treeNodes.length} nodes.`);
      for (let i = 0, l = treeNodes.length; i < l; i++) {
        if (treeNodes[i].drag === false) {
          this.curDragNodes = null;
          return false;
        } else if (treeNodes[i].parentTId && treeNodes[i].getParentNode().childDrag === false) {
          this.curDragNodes = null;
          return false;
        }
      }
      this.curDragNodes = treeNodes;
      return true;
    },
    beforeDragOpen(treeId, treeNode) {
      this.autoExpandNode = treeNode;
      return true;
    },
    // eslint-disable-next-line
    beforeDrop(treeId, treeNodes, targetNode, moveType, isCopy) { // 移动完成回调
      if (targetNode.id === 1) {
        return false;
      }
      // 标记拖拽开始
      this.isDropInProgress = true;
      // 保存拖拽信息，在onDrop中处理
      this.pendingDropInfo = {
        treeNodes,
        targetNode,
        moveType,
        isCopy
      };
      return true; // 允许拖拽
    },
    // eslint-disable-next-line
    onDrag(event, treeId, treeNodes) {
      this.className = (this.className === 'dark' ? '' : 'dark');
    },
    // eslint-disable-next-line
    onDrop(event, treeId, treeNodes, targetNode, moveType, isCopy) {
      this.className = (this.className === 'dark' ? '' : 'dark');
      // 检查是否有待处理的拖拽操作
      if (this.pendingDropInfo) {
        const { treeNodes: pendingTreeNodes, targetNode: pendingTargetNode, moveType: pendingMoveType } = this.pendingDropInfo;
        // 提示用户即将发生的操作
        this.$confirm(`您确定要将新添加的标签移动到'${pendingTargetNode.name}'之${pendingMoveType === 'prev' ? '前' : '后'}吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.handleDropConfirm(pendingTreeNodes, pendingTargetNode, pendingMoveType);
        }).catch(() => {
          // 用户取消操作，恢复原始状态
          $.fn.zTree.init($('#treeDemo'), this.setting, this.zNodes);
        }).finally(() => {
          // 清除待处理的拖拽信息
          this.pendingDropInfo = null;
        });
      }
    },
    onExpand(event, treeId, treeNode) {
      if (treeNode === this.autoExpandNode) {
        this.className = (this.className === 'dark' ? '' : 'dark');
      }
    },
    showLog(str) {
      if (!this.log) {
        this.log = $('#log');
      }
      this.log.append(`<li class='${this.className}'>${str}</li>`);
      if (this.log.children('li').length > 8) {
        this.log.get(0).removeChild(this.log.children('li')[0]);
      }
    },
    getTime() {
      // const now = new Date(),
      //   h = now.getHours(),
      //   m = now.getMinutes(),
      //   s = now.getSeconds(),
      //   ms = now.getMilliseconds();
      // return (`${h}:${m}:${s} ${ms}`);
      return 'getTime';
    },
    setTrigger() {
      const zTree = $.fn.zTree.getZTreeObj('treeDemo');
      zTree.setting.edit.drag.autoExpandTrigger = $('#callbackTrigger').attr('checked');
    },
    addHoverDom(treeId, treeNode) {
      const sObj = $(`#${treeNode.tId}_span`);
      if (treeNode.editNameFlag || $(`#addBtn_${treeNode.tId}`).length > 0) return;
      const addStr = `<span class='button add' id='addBtn_${treeNode.tId
      }' title='add node' onfocus='this.blur();'></span>`;
      sObj.after(addStr);
      const btn = $(`#addBtn_${treeNode.tId}`);
      if (btn) {
        btn.bind('click', () => {
          const zTree = $.fn.zTree.getZTreeObj('treeDemo');
          zTree.addNodes(treeNode, { id: (100 + this.newCount), pId: treeNode.id, name: `new node${this.newCount++}` });
          return false;
        });
      }
    },
    removeHoverDom(treeId, treeNode) {
      $(`#addBtn_${treeNode.tId}`).unbind().remove();
    },
    beforeRemove(treeId, treeNode) {
      const zTree = $.fn.zTree.getZTreeObj('treeDemo');
      zTree.selectNode(treeNode);
      // eslint-disable-next-line
      return confirm(`确认删除 节点 -- ${treeNode.name} 吗？`);
    },
    beforeRename(treeId, treeNode, newName) {
      if (newName.length === 0) {
        setTimeout(() => {
          const zTree = $.fn.zTree.getZTreeObj('treeDemo');
          zTree.cancelEditName();
        }, 0);
        return false;
      }
      return true;
    },
    getFont(treeId, node) {
      return node.font ? node.font : {};
    },
    documentClickEvent() {
      this.visible = false;
    },
    clickHandler() {},
    // 处理拖拽确认后的节点重新排序 treeNodes - 被拖拽的节点数组（通常只有一个节点） targetNode - 目标节点（拖拽到的位置） moveType - 移动类型（'prev' 或 'next'）
    handleDropConfirm(treeNodes, targetNode, moveType) {
      // 找到当前拖拽的节点在 zNodes 中的位置
      const draggedNode = treeNodes[0]; // 获取第一个（也是唯一的）拖拽节点
      const draggedNodeIndex = this.zNodes.findIndex(node => node.id === draggedNode.id);
      // 验证拖拽节点是否存在
      if (draggedNodeIndex === -1) {
        /* eslint no-console: ["error", { allow: ["warn", "error"] }] */
        console.error('拖拽节点未找到');
        return;
      }
      // 过滤掉根节点（id=1的节点），只处理实际的标签节点
      const validNodes = this.zNodes.filter(node => node.id !== 1);
      // 按 orderNum 对有效节点进行排序，确保顺序正确
      const sorted = [...validNodes].sort((a, b) => a.orderNum - b.orderNum);
      // 找到拖拽节点和目标节点在排序后数组中的位置
      const draggedNodeInSorted = sorted.findIndex(node => node.id === draggedNode.id);
      const targetNodeInSorted = sorted.findIndex(node => node.id === targetNode.id);
      // 验证节点位置计算是否正确
      if (draggedNodeInSorted === -1 || targetNodeInSorted === -1) {
        /* eslint no-console: ["error", { allow: ["warn", "error"] }] */
        console.error('节点位置计算错误');
        return;
      }
      // 计算新的插入位置
      let newInsertIndex = targetNodeInSorted; // 默认插入到目标节点位置
      if (moveType === 'next') {
        // 如果是 'next'，则插入到目标节点之后
        newInsertIndex = targetNodeInSorted + 1;
      }
      // 如果是 'prev'，则插入到目标节点位置（目标节点会向后移动）
      // 重新构建排序后的数组
      const newSorted = [];
      // 添加拖拽节点之前的所有节点（保持原有顺序）
      for (let i = 0; i < draggedNodeInSorted; i++) {
        newSorted.push(sorted[i]);
      }
      // 添加拖拽节点之后的所有节点（跳过拖拽节点本身，避免重复）
      for (let i = draggedNodeInSorted + 1; i < sorted.length; i++) {
        newSorted.push(sorted[i]);
      }
      // 重新计算插入位置（因为移除了拖拽节点，索引会变化）
      let adjustedInsertIndex = newInsertIndex;
      if (draggedNodeInSorted < newInsertIndex) {
        // 如果拖拽节点在目标位置之前，移除后目标位置会向前移动一位
        adjustedInsertIndex = newInsertIndex - 1;
      }
      // 在调整后的目标位置插入拖拽节点
      newSorted.splice(adjustedInsertIndex, 0, sorted[draggedNodeInSorted]);
      // 重新计算所有节点的 orderNum，确保连续且无重复
      let currentOrderNum = 1;
      for (let i = 0; i < newSorted.length; i++) {
        newSorted[i].orderNum = currentOrderNum; // 设置新的 orderNum
        // 更新节点名称，格式为 "orderNum:labelName"
        newSorted[i].name = `${currentOrderNum}:${newSorted[i].labelName || newSorted[i].name.split(':').slice(1).join(':')}`;
        currentOrderNum++; // 递增 orderNum
      }
      // 重新构建完整的 zNodes 数组，保持根节点在第一位
      const rootNode = this.zNodes.find(node => node.id === 1); // 找到根节点
      this.zNodes = rootNode ? [rootNode, ...newSorted] : newSorted; // 根节点 + 重新排序的标签节点
      // 更新当前选中的标签名称（用于显示在输入框中）
      this.labelName = sorted[draggedNodeInSorted].name;
      // 重新初始化 zTree，更新界面显示
      $.fn.zTree.init($('#treeDemo'), this.setting, this.zNodes);
      $('#callbackTrigger').bind('change', {}, this.setTrigger);
      this.className = (this.className === 'dark' ? '' : 'dark');
      // 将新的位置信息传递给父组件
      this.$emit('sendTarget', targetNode.id, moveType);
      // 重置拖拽状态，防止拖拽后意外触发 getLabelName 方法
      this.isDropInProgress = false;
    },
    // 此方法废弃
    getLabelPriorityInfo(companyId, nodeId, orderNum, isCanEdit, isCanEditPriority) {
      if (isCanEdit || isCanEdit === undefined) {
        this.isDisable = false;
      } else {
        this.isDisable = true;
      }
      if (isCanEditPriority || isCanEditPriority === undefined) {
        this.isDisablePriority = false;
      } else {
        this.isDisablePriority = true;
      }

      this.currentId = nodeId;
      this.initDate();
      this.$ajax({
        url: '/label/getLabelPriority',
        prompt: true,
        method: 'POST',
        data: { 'companyId': companyId }
      }).then((res) => {
        if (res.code === 601) {
          // this.$message({
          //   message: orderNum,
          //   type: 'warning'
          // });
          if (orderNum === 1) {
            this.targetOrderNum = 2;
          } else {
            this.targetOrderNum = orderNum - 1;
          }
          for (let index = 0; index < res.data.length; index++) {
            res.data[index].name = `${res.data[index].orderNum}:${res.data[index].labelName}`;
            if (nodeId !== null && nodeId === res.data[index].id) {
              if (isCanEditPriority) {
                res.data[index].icon = '../../../../static/plugins/ztree/css/zTreeStyle/img/diy/2.png';
                res.data[index].drag = true;
              }
              this.labelName = res.data[index].name;
            }
            // 判断当前标签的位置
            if (isCanEditPriority && res.data[index].orderNum === this.targetOrderNum) {
              this.targetLabel = res.data[index];
              if (orderNum === 1) {
                this.targetLabelType = 'prev';
                this.moveDirectUp = false;
              } else {
                this.targetLabelType = 'next';
                this.moveDirectUp = true;
              }
            }
          }
          this.zNodes = res.data;
          this.num = res.data.length + 1;
          $.fn.zTree.init($('#treeDemo'), this.setting, this.zNodes);
          $('#callbackTrigger').bind('change', {}, this.setTrigger);
          this.$emit('treeLoaded');
        }
      });
    },
    initDate() {
      this.num = 0;
      this.labelName = '';
      this.targetLabel = null;
      this.targetLabelType = null;
      this.isHave = false;
      this.newZnodes = [];
      this.startPoint = null;
      this.endPoint = null;
      this.moveDirectUp = true;
      this.isDropInProgress = false;
    },
    getLabelName(labelName) {
      // 如果正在拖拽中，不执行添加逻辑
      if (this.isDropInProgress) {
        return;
      }
      if (this.labelName !== labelName) {
        this.isHave = false;
        // 查找是否已经添加过ID为0的元素，如果没有那么重新添加，如果有那么修改名称
        for (let i = 0; i < this.zNodes.length; i++) {
          if (this.zNodes[i].id === this.currentId) {
            this.zNodes[i].name = `${this.zNodes[i].orderNum}:${labelName}`;
            this.zNodes[i].labelName = labelName;
            $.fn.zTree.init($('#treeDemo'), this.setting, this.zNodes);
            $('#callbackTrigger').bind('change', {}, this.setTrigger);
            this.isHave = true;
            this.labelName = `${this.zNodes[i].orderNum}:${labelName}`;
            break;
          }
        }
        if (!this.isHave) {
          this.currentId = 0;
          // 过滤掉根节点（id=1的节点）
          const validNodes = this.zNodes.filter(node => node.id !== 1);
          // 按 orderNum 排序
          const sorted = [...validNodes].sort((a, b) => a.orderNum - b.orderNum);
          // 找到"首次发送"标签的位置
          const firstSendIndex = sorted.findIndex((item) => {
            const label = item.labelName || (item.name ? item.name.split(':').slice(1).join(':') : '');
            return label === '首次发送';
          });
          // 计算新标签的插入位置和 orderNum
          let insertIndex = 0;
          let newOrderNum = 1;
          let targetId = null;
          if (firstSendIndex !== -1) {
            // 如果找到"首次发送"，新标签插入到"首次发送"之前
            insertIndex = firstSendIndex;
            newOrderNum = sorted[firstSendIndex].orderNum;
            targetId = firstSendIndex > 0 ? sorted[firstSendIndex - 1].id : null;
          } else {
            // 如果没有"首次发送"，插入到最后位置
            insertIndex = sorted.length;
            newOrderNum = sorted.length > 0 ? sorted[sorted.length - 1].orderNum + 1 : 1;
            targetId = sorted.length > 0 ? sorted[sorted.length - 1].id : null;
          }
          // 创建新标签
          const newNode = {
            id: 0,
            pId: 0,
            name: `${newOrderNum}:${labelName}`,
            labelName,
            upIs: 1,
            orderNum: newOrderNum,
            icon: '../../../../static/plugins/ztree/css/zTreeStyle/img/diy/2.png',
            font: { color: 'red' }
          };
          // 重新构建 zNodes 数组，保持根节点在第一位
          const rootNode = this.zNodes.find(node => node.id === 1);
          const newZNodes = rootNode ? [rootNode] : [];
          // 重新排列所有节点
          let currentOrderNum = 1;
          // 按顺序添加所有节点，在指定位置插入新标签
          for (let i = 0; i < sorted.length; i++) {
            if (i === insertIndex) {
              // 在指定位置插入新标签
              newNode.orderNum = currentOrderNum;
              newNode.name = `${currentOrderNum}:${labelName}`;
              newZNodes.push(newNode);
              currentOrderNum++;
            }
            // 添加当前节点
            const node = sorted[i];
            node.orderNum = currentOrderNum;
            node.name = `${currentOrderNum}:${node.labelName || node.name.split(':').slice(1).join(':')}`;
            newZNodes.push(node);
            currentOrderNum++;
          }
          // 如果新标签应该插入到最后
          if (insertIndex === sorted.length) {
            newNode.orderNum = currentOrderNum;
            newNode.name = `${currentOrderNum}:${labelName}`;
            newZNodes.push(newNode);
          }
          this.zNodes = newZNodes;
          $.fn.zTree.init($('#treeDemo'), this.setting, this.zNodes);
          $('#callbackTrigger').bind('change', {}, this.setTrigger);
          this.labelName = `${newNode.orderNum}:${labelName}`;
          this.$emit('sendTarget', targetId, 'next');
        }
      }
    }
  },
  mounted() {
    this.$emit('initLabelData', 'getLabelInfo');
  }
};
</script>

<style lang="less">
  @import "../../../../static/plugins/ztree/css/zTreeStyle/zTreeStyle.css";
  #areaTree{
    margin-bottom: 2px;
    border-radius: 4px;
    .tree-box {
      position: relative;
      .tree-box__input {
        width: 100%;
        height: 30px;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
      }
      .zTreeDemoBackground {
        position: absolute;
        width: 100%;
        top: 33px;
        left: 0;
        background: #fbfbfb;
        border-radius: 3px;
        border: 1px solid #dcdfe6;
        z-index: 20;
      }
    }
  }
  /*.el-input.is-disabled .el-input__inner .tree-box__input {*/
    /*background-color: white;*/
    /*border-color: #e4e7ed;*/
    /*color: #c0c4cc;*/
    /*cursor: not-allowed;*/
  /*}*/
  .box-title{
    border-radius: 3px 3px 0 0;background-color: #f5f5f5;
  }
  .box-title a{
    color: #2fa4e7;
    text-decoration: none;font-size:14px;    display: block;
    padding: 8px 15px;cursor: pointer;
  }
  .box-title .fa{
    float:right;line-height: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/page/main/ztree/treeDemo.vue